<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="options.icon" class="mr-1"></i>
            <span>{{ options.title }}</span>
          </b-col>
          <b-col cols="12" sm="6" class="mt-2 mt-sm-0">
            <div class="card-header-actions">
              <div style="display: flex; justify-content: space-between">
                <b-button
                  @click="showfilter = !showfilter"
                  :pressed="!showfilter"
                  variant="outline-primary"
                  class="card-header-action mr-1"
                  squared
                  size="sm"
                  title="Show/Hide Filter"
                >
                  <i class="fa fa-filter"></i
                ></b-button>
                <b-form-group size="sm" class="mb-0">
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="btable_find"
                      placeholder="Find"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        style="width: auto; padding: 0.25rem 0.6rem"
                        variant="outline-primary"
                        :disabled="!btable_find"
                        @click="btable_find = ''"
                      >
                        <i v-if="btable_find" class="fa fa-remove"></i>
                        <i v-if="!btable_find" class="fa fa-search"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <!-- <b-row no-gutters v-if="showfilter">
              <b-col>
                <b-button
                  @click="showfilter = !showfilter"
                  variant="link"
                  class="card-header-action"
                  squared
                  size="sm"
                >
                  <i class="fa fa-filter pr-2"></i>Filter...</b-button
                >
              </b-col>
            </b-row> -->
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect
                    placeholder="Select event..."
                    searchPromptText="Type at least 4 chars..."
                    v-model="eventcode"
                    :clearable="true"
                    :async="true"
                    :load-options="treeselect_loadEvent"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Client SL A/C"
                  label-size="sm"
                >
                  <treeselect
                    placeholder="Select slac..."
                    searchPromptText="Type at least 3 chars..."
                    v-model="slac"
                    :multiple="true"
                    :clearable="true"
                    :async="true"
                    :load-options="treeselect_loadSLAC"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                    :disabled="
                      user.rolename == 'api' || user.rolename == 'client'
                    "
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Passenger" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      v-model="passenger"
                      placeholder="Passenger"
                      trim
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!passenger"
                        @click="passenger = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <b-row class="px-0 mt-0">
            <b-col cols="auto">
              <b-button-group class="z-0">
                <b-row align-h="start" no-gutters>
                  <b-col
                    cols="auto"
                    v-for="(tool, index) in tools.filter(
                      (o) => o.position == 'toolbar'
                    )"
                    :key="index"
                  >
                    <b-button
                      v-if="tool.type == 'button'"
                      :id="'tool_' + tool.action"
                      :size="tool.size"
                      :variant="tool.variant"
                      :title="tool.label"
                      :squared="tool.squared ? 'squared' : null"
                      :disabled="toolDisabled(tool.action)"
                      @click="toolClick(tool.action)"
                    >
                      <i v-if="tool.icon" :class="tool.icon"></i>
                      <span v-if="tool.label">
                        {{ tool.label }}
                      </span>
                      <i v-if="tool.icon2" :class="tool.icon2"></i> </b-button
                  ></b-col>
                </b-row>
              </b-button-group>
            </b-col>
            <b-col>
              <b-row align-h="end" no-gutters>
                <b-col
                  cols="auto"
                  v-for="(tool, index) in options.view"
                  :key="index"
                >
                  <span v-if="tool.type == 'label'" :class="tool.class">
                    {{ tool.label }}
                  </span>
                  <b-form-radio-group
                    v-if="tool.type == 'radio-group'"
                    :options="tool.options"
                  >
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="px-3">
          <b-overlay
            :show="options.overlay_show"
            opacity=".9"
            v-click-outside="outside"
          >
            <div>
              <b-table
                :dark="$store.state.darkMode"
                ref="btable"
                :sticky-header="btable_height + 'px'"
                striped
                hover
                small
                caption-bottom
                show-empty
                selectable
                select-mode="multi"
                :busy="btable_busy"
                :items="btable_items"
                :filter="btable_find"
                :fields="options.fields"
                @row-selected="btable_rowSelected"
              >
                <template #head(selected)>
                  <i
                    id="selectall"
                    class="ml-1"
                    :class="btable_iconselected()"
                    aria-hidden="true"
                    @click="btable_iconselectedClick()"
                    title="Click to select/unselect all"
                  ></i>
                  <b-tooltip
                    target="selectall"
                    triggers="hover"
                    placement="right"
                    >Click to select/unselect all</b-tooltip
                  >
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner
                      type="grow"
                      variant="primary"
                      class="align-middle mr-2"
                    ></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)="slot">
                  <i :class="btable_icon(slot.item)"></i>
                </template>

                <template v-slot:cell()="row">
                  <div
                    v-if="
                      options.badges &&
                      options.badges.find((obj) => obj.key == row.field.key)
                    "
                  >
                    <span
                      v-html="
                        btable_rowBadgeCell(
                          row.item,
                          options.badges.find(
                            (obj) => obj.key == row.field.key
                          ),
                          options
                        )
                      "
                    ></span>
                  </div>
                  <div v-else>{{ row.value }}</div>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button
                      variant="link"
                      size="sm"
                      title="Actions"
                      :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')"
                    >
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover
                      container="actions-container"
                      triggers="click blur"
                      placement="leftbottom"
                      :target="'popover-target-' + row.item.id"
                    >
                      <div>
                        <b-nav vertical>
                          <b-nav-item
                            :title="action.label"
                            v-for="action in btable_rowActionCell(
                              row.item,
                              options
                            )"
                            :key="action.key"
                            @click.stop="btable_rowClick(action.key, row)"
                          >
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i
                                  :class="
                                    btable_rowActionIcon(action, row.item)
                                  "
                                ></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button
                      variant="link"
                      size="sm"
                      v-for="action in btable_rowActionCell(row.item, options)"
                      :key="action.key"
                      @click.stop="btable_rowClick(action.key, row)"
                      :title="action.label"
                    >
                      <i :class="btable_rowActionIcon(action, row.item)"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details>
                  <b-card>
                    <component
                      :is="options.component.name"
                      :selection="btable_selected"
                      :config="cconfig"
                      @discard="toolClick('discard')"
                      @refresh="toolClick('refresh')"
                    ></component>
                  </b-card>
                </template>
              </b-table>
            </div>

            <template #overlay>
              <div class="text-center">
                <p id="cancel-label">{{ options.overlay.message }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button
                      v-for="(button, index) in options.overlay.buttons"
                      :key="index"
                      :style="button.style ? button.style : 'width: 80px'"
                      :class="
                        button.class
                          ? button.class
                          : button.dispatch
                          ? null
                          : 'ml-2'
                      "
                      :variant="
                        button.variant
                          ? button.variant
                          : button.dispatch
                          ? 'outline-primary'
                          : 'outline-secondary'
                      "
                      :size="button.size ? button.size : 'sm'"
                      :squared="button.squared ? button.squared : true"
                      @click="
                        button.dispatch
                          ? toolClick(button.dispatch)
                          : (options.overlay_show = false)
                      "
                      >{{ button.label }}</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-overlay>
        </div>
      </div>
      <div v-if="component">
        <component
          :is="component"
          :selection="btable_selected"
          :config="cconfig"
          @fileit="fileit"
          @saveit="saveit"
          @discard="toolClick('discard')"
          @refresh="toolClick('refresh')"
        ></component>
      </div>

      <b-row v-if="!component" class="excelsheetbuttons px-3">
        <b-col>
          <div v-if="btable_busy">
            <i class="fa fa-spinner fa-spin text-primary"></i>
            <span class="small text-primary ml-1">Updating ...</span>
          </div>
          <span v-if="!btable_busy" class="small text-primary"
            >Found {{ btable_items.length }} rows</span
          >
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import ItineraryView from "./Components/ItineraryView";
import ItineraryData from "./Components/ItineraryData";

export default {
  name: "Itineraries",
  components: { ItineraryView, ItineraryData },
  watch: {
    async eventcode() {
      await this.load();
    },
    async slac() {
      await this.load();
    },
    async passenger() {
      await this.load();
    },
  },
  data() {
    return {
      busy: false,
      id: null,
      slac: null,
      eventcode: null,
      passenger: null,
      datetravel: null,
      options: {
        title: "Client Itineraries",
        icon: "fa fa-suitcase",
        debounce: 500,
        tools: [],
        view: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-30px",
          },
          {
            key: "passenger",
            label: "Passenger",
            class: "text-left",
            sortable: true,
          },
          {
            key: "email",
            label: "Email found",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
          },
          {
            key: "days",
            label: "Travel Days",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-110px",
          },
        ],
        badges: [
          {
            key: "booked",
            type: "pill",
            class: "success",
          },
          {
            key: "emailfound",
            type: "badge",
            Yes: "success",
            No: "danger",
            formatter: (value, key, item) => {
              if (value) {
                return "Yes";
              } else {
                return "No";
              }
            },
          },
        ],
        actions: [
          {
            key: "view",
            label: "View",
            icon: "fa fa-search-plus",
            single: true,
            multiple: false,
            component: {
              name: "ItineraryView",
            },
          },
          {
            key: "data",
            label: "Itinerary Data",
            icon: "fa fa-sitemap",
            single: true,
            multiple: false,
            component: {
              name: "ItineraryData",
            },
          },
          //   {
          //     key: "edit",
          //     label: "Edit",
          //     icon: "fa fa-pencil",
          //     single: true,
          //     multiple: false,
          //     component: {
          //       name: "FlightsEdit",
          //     },
          //   },
        ],
        actions_as_elipses: false,
        modal: {},
        component: {},
        overlay_show: false,
        overlay: {},
      },
    };
  },
  mounted() {
    this.resizableColumns();

    // Mix common tools with local tools
    this.tools = [...this.tools, ...this.options.tools];
    this.toolRemove("copy,add,import,archive");
  },
  methods: {
    async load() {
      this.btable_items = [];

      // NO WILDCARD SEARCHES
      if (!this.eventcode) {
        return;
      }

      this.btable_busy = true;

      let variables = {
        eventcode: this.eventcode,
        slac: this.slac ? this.slac.join(",") : null,
        passenger: this.passenger,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query itineraries(
              $eventcode: String
              $slac: String
              $passenger: String
            ) {
              itineraries(
                eventcode: $eventcode
                slac: $slac
                passenger: $passenger
              ) {
                id
                eventcode
                slac
                passenger
                email
                days
              }
            }
          `,
          variables,
        });

        this.btable_items = response.data.itineraries;
      } catch (error) {
        console.log(error);
      }
      this.btable_busy = false;
    },
  },
};
</script>